import script from "./InternalTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalTickets.vue?vue&type=script&setup=true&lang=js"

import "./InternalTickets.vue?vue&type=style&index=0&id=84fa1d8a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84fa1d8a"]])

export default __exports__